export default "__VITE_ASSET__739049f2__"